var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.elementType,{tag:"component"},[_vm._l((_vm.list),function(item,index){return _vm._t("item",[_c('ListItem',{key:typeof item === 'object' ? item[_vm.keyProperty] : (item + "-" + index),attrs:{"item":item}})],{"item":item})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }